import { combineReducers } from 'redux';

import { serviceAgreementReducer } from './serviceAgreement.reducer';

export const taskFormReducers = combineReducers({
	serviceAgreementReducer
});
